import React, { useEffect, useState, useMemo } from "react";
import "./style.scss";
import ChartGain from "../../../assets/images/chart-rep-gain.png";
import ChartLoss from "../../../assets/images/chart-rep-loss.png";
import StarBlueIcon from "../../../assets/icons/star-blue-icon.svg";
import StarGreyIcon from "../../../assets/icons/star-gray-icon.svg";
import ArrowUpIcon from "../../../assets/icons/arrow-up-white.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/CopyIcon.svg";
import { ReactComponent as BrandCopyIcon } from "../../../assets/icons/BrandCopyIcon.svg";
import { Link } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ReactComponent as SearchNew } from "../../../assets/icons/search-svgrepo-com (1).svg";
import { country as countryList } from "../../../utils/constants/country";
import { useDispatch, useSelector } from "react-redux";
import {
  generateContractRequest,
  getSupportTableDetailsNew,
} from "../../../utils/api/apis";
import { returnErrors } from "../../../store/reducers/error";
import { setIsLoading } from "../../../store/reducers/authSlice";
import moment from "moment";
import { returnMessages } from "../../../store/reducers/message";
import Select from "react-select";
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import CrossMark from "../../../assets/images/delete_14024972.png";
import RightMark from "../../../assets/images/check_5610944.png";
import {
  setActiveAccount,
  setActiveUser,
} from "../../../store/reducers/accountSlice";
import { Button } from "rsuite";
import ReactTable from "../../../reusableComponents/ReactTable/ReactTable";
// Import the reusable table

// --- Helper Components ---
function Importance({ activeStars }) {
  let totalStars = 3;
  let inactiveStars = totalStars - activeStars;
  const stars = [];
  for (let i = 0; i < activeStars; i++) {
    stars.push(
      <img
        src={StarBlueIcon}
        alt=""
        key={`active${i}`}
        className="importance-star"
      />
    );
  }
  for (let i = 0; i < inactiveStars; i++) {
    stars.push(
      <img
        src={StarGreyIcon}
        alt=""
        key={`inactive${i}`}
        className="importance-star"
      />
    );
  }
  return <>{stars}</>;
}

// Action Cell Component (Moved out for cleaner main component)
const ActionCell = ({ row, fetchData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.auth.idToken);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleConfirmOpen = (action) => {
    setSelectedAction(action);
    setConfirmOpen(true);
    handleClose(); // Close menu when dialog opens
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
    setSelectedAction("");
  };

  const handleGenerateContract = async () => {
    const data = {
      action: selectedAction
        ? selectedAction
        : row?.original?.contract_issued
        ? "revoke"
        : "generate",
    };

    dispatch(setIsLoading(true));
    try {
      const response = await generateContractRequest(
        idToken,
        row?.original?.id,
        data
      );
      if (response?.data?.detail) {
        dispatch(returnMessages(response?.data?.detail, response?.status));

        fetchData(); // Refresh data
      } else {
        dispatch(
          returnErrors(
            response?.response?.data?.detail,
            response?.response?.status
          )
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
    handleConfirmClose();
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Actions">
          <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            minWidth: "150px",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {row?.original.status === "approved" ? (
          <MenuItem disabled>No Actions</MenuItem>
        ) : (
          <>
            {row?.original.status === "new" && (
              <>
                <MenuItem
                  onClick={() =>
                    handleConfirmOpen(
                      row?.original.contract_issued ? "revoke" : "generate"
                    )
                  }
                >
                  {row?.original.contract_issued ? "Revoke" : "Generate"}{" "}
                  contract
                </MenuItem>
                <MenuItem onClick={() => handleConfirmOpen("reject")}>
                  Reject Contract
                </MenuItem>
              </>
            )}
            {["rejected", "revoked", "in_progress"].includes(
              row?.original.status
            ) && (
              <MenuItem onClick={() => handleConfirmOpen("hard_reset")}>
                Hard Reset
              </MenuItem>
            )}
          </>
        )}
      </Menu>

      <Dialog open={confirmOpen} onClose={handleConfirmClose}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {selectedAction?.replace("_", " ")} this
            contract?
          </DialogContentText>
        </DialogContent>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 24px 20px",
          }}
        >
          <Button appearance="ghost" color="red" onClick={handleConfirmClose}>
            Cancel
          </Button>
          <Button appearance="primary" onClick={handleGenerateContract}>
            Confirm
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

// --- Main Component ---
function StagePass2({ type }) {
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.auth.idToken);
  const { selectedBrand } = useSelector((state) => state.brand);

  const [searchedValue, setSearchedValue] = useState("");

  // Consolidated State for ReactTable
  const [params, setParams] = useState({
    page: 1,
    page_size: 50,
    search: null,
    status: null,
    platform: null,
    duplicatesBrowser: false,
    severity: null, // kept for existing logic, though unused in UI currently
  });

  useEffect(() => {
    setSearchedValue("");
    setParams((prev) => ({
      ...prev,
      search: null,
      page: 1,
    }));
  }, [type]);

  const [totalTraders, setTotalTraders] = useState(0);
  const [allTraders, setAllTraders] = useState([]);

  // Data Fetching
  const fetchData = async () => {
    dispatch(setIsLoading(true));
    try {
      // API expects arguments: idToken, page, type, severity, status, search, platform, brand, duplicates
      const data = await getSupportTableDetailsNew(
        idToken,
        params.page,
        type,
        params.severity || "",
        params.status || null,
        params.search || "",
        params.platform,
        selectedBrand,
        params.duplicatesBrowser
      );
      setTotalTraders(data.count);
      setAllTraders(data.results);
    } catch (error) {
      dispatch(returnErrors("Something went wrong", 400));
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params.page,
    params.status,
    params.search,
    params.platform,
    params.duplicatesBrowser,
    selectedBrand,
    type,
  ]);

  // Search Handler
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setParams((prev) => ({
      ...prev,
      search: searchedValue,
      page: 1,
    }));
  };

  // Actions
  const handleCopyToClipboard = () => {
    toast.success("Copied email", { position: "top-right", theme: "dark" });
  };

  const handleActiveAccount = (row, msg) => {
    if (row?.account && msg === "account") dispatch(setActiveAccount(row));
    else if (row?.account && msg === "funded_account")
      dispatch(setActiveAccount(row));
    else dispatch(setActiveAccount(null));
    dispatch(setActiveUser({ ...row }));
  };

  const typename =
    type === "1_step"
      ? "Stage 1"
      : type === "pro_edge"
      ? "Pro Edge"
      : "Stage 2";

  // Columns Definition
  const columns = useMemo(
    () => [
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ value }) => (
          <div className="column_one_wrapper">
            <div>{value}</div>
            <CopyToClipboard onCopy={handleCopyToClipboard} text={value}>
              <p
                className="table_copy_button"
                style={{ marginRight: "20px", cursor: "pointer" }}
              >
                {selectedBrand?.brand === "crypto_edge" ? (
                  <BrandCopyIcon />
                ) : (
                  <CopyIcon />
                )}
              </p>
            </CopyToClipboard>
          </div>
        ),
      },
      {
        Header: "Full Name",
        accessor: "full_name",
        Cell: ({ value }) => <>{value || "-"}</>,
      },
      ...(type === "2_step"
        ? [
            {
              Header: "Stage 1",
              accessor: "stage_1",
              Cell: ({ row, value }) => (
                <Link
                  to="/traders-list-2"
                  onClick={() => handleActiveAccount(row.original, "account")}
                >
                  {value || "-"}
                </Link>
              ),
            },
          ]
        : []),
      {
        Header: typename,
        accessor: "account",
        Cell: ({ row, value }) => (
          <Link
            to="/traders-list-2"
            onClick={() => handleActiveAccount(row.original, "account")}
          >
            {value || "-"}
          </Link>
        ),
      },
      {
        Header: "Funded",
        accessor: "funded_account",
        Cell: ({ row, value }) => (
          <Link
            to="/traders-list-2"
            onClick={() => handleActiveAccount(row.original, "funded_account")}
          >
            {value || "-"}
          </Link>
        ),
      },
      {
        Header: "Account Size",
        accessor: "account_size",
        Cell: ({ row, value }) => (
          <Link
            to="/traders-list-2"
            onClick={() => handleActiveAccount(row.original, "funded_account")}
          >
            {value || "-"}
          </Link>
        ),
      },
      {
        Header: "Plan",
        accessor: "plan",
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span
            style={{
              textTransform: "capitalize",
              color:
                value === "approved"
                  ? "#209829"
                  : value === "rejected"
                  ? "#FA4D4D"
                  : value === "new"
                  ? "#00000"
                  : "#FFB100",
            }}
          >
            {value ? value.replace(/_/g, " ") : "-"}
          </span>
        ),
      },
      {
        Header: "Importance",
        accessor: "importance",
        Cell: ({ value }) => <Importance activeStars={value || 0} />,
      },
      {
        Header: "Issue Type",
        accessor: "issue_type",
        Cell: ({ value }) => (
          <p style={{ textTransform: "capitalize" }}>{value || "-"}</p>
        ),
      },
      {
        Header: "Country",
        accessor: "country",
        Cell: ({ value }) => {
          if (!value) return <p>-</p>;
          const found = countryList.find(
            (c) => c.iso.toLowerCase() === value.toLowerCase()
          );
          return (
            <p style={{ textTransform: "capitalize" }}>
              {found ? found.country : value}
            </p>
          );
        },
      },
      {
        Header: "Browser Id",
        accessor: "browser_id",
        Cell: ({ row }) => <p>{row?.original?.meta?.browser_id || "-"}</p>,
      },
      {
        Header: "Contract Issued",
        accessor: "contract_issued",
        Cell: ({ row }) => (
          <img
            width="25px"
            src={
              row?.original.contract_issued ||
              row?.original.status === "approved"
                ? RightMark
                : CrossMark
            }
            alt=""
          />
        ),
      },
      {
        Header: "KYC verified",
        accessor: "kyc_verified",
        Cell: ({ row }) => (
          <img
            width="25px"
            src={row?.original.kyc_verified ? RightMark : CrossMark}
            alt=""
          />
        ),
      },
      {
        Header: "Date (created)",
        accessor: "created_at",
        Cell: ({ value }) => moment.utc(value).format("MMM Do YYYY, h:mm a"),
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => <ActionCell row={row} fetchData={fetchData} />,
      },
    ],
    [typename, type, selectedBrand, params.search]
  );

  const statusOptions = [
    { label: "All", value: null },
    { label: "New", value: "new" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];

  // Custom Row Sub-Component (The Summary View)
  const renderSummaryView = ({ row }) => (
    <div className="supportcases-td-container">
      <div className="td-main-div">
        <h3>Stage - I Evaluation Summary</h3>
        <div className="supportcases-type-details">
          <div className="supportcases-box">
            <p>Martingale success</p>
            <h4>${row.successRate}</h4>
            <div className="success-ratio">
              <span>
                <img src={ArrowUpIcon} alt="" />
              </span>{" "}
              +2.53%
            </div>
          </div>
          <div className="supportcases-box">
            <p>Max Loss</p>
            <h4 className="red">${row.maxLoss}</h4>
            <img src={ChartLoss} alt="" />
          </div>
          <div className="supportcases-box">
            <p>Max Daily Loss</p>
            <h4 className="red">${row.maxDailyLoss}</h4>
            <img src={ChartLoss} alt="" />
          </div>
          <div className="supportcases-box">
            <p>Min Trading Days</p>
            <h4 className="green">{row.minTradeDays}</h4>
            <img src={ChartGain} alt="" />
          </div>
          <div className="supportcases-box dates">
            <div className="report-dates">
              <div className="upper-date">
                <p>Purchase Date</p>
                <h4>{row.purchaseDt}</h4>
              </div>
              <div className="lower-date">
                <p>Account Started</p>
                <h4>{row.reportDt}</h4>
              </div>
            </div>
            <div className="report-dates">
              <div className="upper-date">
                <p>ADTI Report</p>
                <h4>{row.accStartDt}</h4>
              </div>
              <div className="lower-date">
                <p>Account Pass</p>
                <h4>{row.accPassDt}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="supportcases-comments">
          <p>Comments</p>
          <h4>{row.desc}</h4>
          <Link to="">Click here for full event details.</Link>
        </div>
      </div>
    </div>
  );

  return (
    <div className="economiccalender-container">
      <div className="economiccalender-subcontainer">
        <div className="economiccalender-innercontainer filter-header">
          <form className="search_container" onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Search..."
              value={searchedValue}
              onChange={(e) => setSearchedValue(e.target.value)}
            />
            <button type="submit">
              <div style={{ padding: "3px 10px 0 0" }}>
                <SearchNew style={{ width: "100%" }} />
              </div>
            </button>
          </form>

          <div className="sort_buttons">
            <div className="mobile_dropDowns">
              <Select
                placeholder="Status"
                options={statusOptions}
                value={statusOptions.find((o) => o.value === params.status)}
                onChange={(opt) =>
                  setParams((prev) => ({ ...prev, status: opt.value, page: 1 }))
                }
              />
            </div>
            <div
              className="tabContainer desktop_pills"
              style={{ display: "flex", gap: "6px" }}
            >
              {statusOptions.map((tab, index) => (
                <div
                  key={index}
                  className={
                    params.status === tab.value ? "active" : "normalbtn"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setParams((prev) => ({
                      ...prev,
                      status: tab.value,
                      page: 1,
                    }))
                  }
                >
                  {tab.label}
                </div>
              ))}
              {selectedBrand?.brand === "equity_edge" && (
                <>
                  <div
                    className={
                      params.platform === "matchtrade" ? "active" : "normalbtn"
                    }
                    onClick={() =>
                      setParams((prev) => ({
                        ...prev,
                        platform: "matchtrade",
                        page: 1,
                      }))
                    }
                  >
                    Matchtrade
                  </div>
                  <div
                    className={
                      params.platform === "tradelocker" ? "active" : "normalbtn"
                    }
                    onClick={() =>
                      setParams((prev) => ({
                        ...prev,
                        platform: "tradelocker",
                        page: 1,
                      }))
                    }
                  >
                    Tradelocker
                  </div>
                  <div
                    className={
                      params.platform === "mt5" ? "active" : "normalbtn"
                    }
                    onClick={() =>
                      setParams((prev) => ({
                        ...prev,
                        platform: "mt5",
                        page: 1,
                      }))
                    }
                  >
                    MT5
                  </div>
                  <div
                    className={
                      params.duplicatesBrowser ? "active" : "normalbtn"
                    }
                    onClick={() =>
                      setParams((prev) => ({
                        ...prev,
                        duplicatesBrowser: !prev.duplicatesBrowser,
                        page: 1,
                      }))
                    }
                  >
                    Duplicate Browser ID
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="economiccalender-container_table">
          <ReactTable
            columns={columns}
            data={allTraders}
            params={params}
            setParams={setParams}
            serverSide={true}
            totalCount={totalTraders}
            renderRowSubComponent={renderSummaryView}
          />
        </div>
      </div>
    </div>
  );
}

export default StagePass2;
